const ErrorNotification = ({ message, className }) => {
  return (
    <div className={className}>
      {message}
    </div>
  );
};

export default ErrorNotification